import React from 'react'
import BallLogo from 'assets/icons/ballLogo.svg'
import {
  PageNotFoundContainer,
  PageNotFoundContent,
  PageNotFoundDescription,
  PageNotFoundTitleContainer,
  PageNotFoundTitlePrimary,
  PageNotFoundTitleSecondary,
} from './PageNotFound.styled'
import SVG from 'react-inlinesvg'
import Button from 'components/Button/Button'
import { useHistory } from 'react-router'

const PageNotFound = () => {
  const { push } = useHistory()
  return (
    <PageNotFoundContainer>
      <PageNotFoundContent>
        <PageNotFoundTitleContainer>
          <PageNotFoundTitlePrimary>4 </PageNotFoundTitlePrimary>
          <SVG src={BallLogo} style={{ marginLeft: '15px' }} />
          <PageNotFoundTitleSecondary> 4</PageNotFoundTitleSecondary>
        </PageNotFoundTitleContainer>
        <PageNotFoundDescription>
          It looks like the page you&#39;re looking for doesn&#39;t exist.
        </PageNotFoundDescription>
        <PageNotFoundDescription>
          Tap the button below to go back.
        </PageNotFoundDescription>
        <Button
          text="Previous Page"
          variant="primary"
          size="large"
          style={{ padding: '0px 50px', marginTop: 50 }}
          onClick={() => push('/')}
        />
      </PageNotFoundContent>
    </PageNotFoundContainer>
  )
}

export default PageNotFound
